import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Button } from '@astryxdesign/core/Button';
import { useNavigate } from 'react-router';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <Center minHeight="80dvh" padding={6}>
      <EmptyState
        title="Страница не найдена"
        description="Возможно, ссылка устарела."
        actions={<Button label="На главную" variant="primary" onClick={() => navigate('/')} />}
      />
    </Center>
  );
}
